import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavbarComponent } from './components/navbar/navbar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FooterComponent } from './components/footer/footer.component';
import { LogoComponent } from './components/logo/logo.component';
import { SubNavbarComponent } from './components/sub-navbar/sub-navbar.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';



@NgModule({
    exports: [
        NavbarComponent,
        BreadcrumbComponent,
        FooterComponent,
        LogoComponent,
        SubNavbarComponent,
        LanguageSelectorComponent,
    ],
    imports: [
        CommonModule,
        NavbarComponent,
        BreadcrumbComponent,
        FooterComponent,
        LogoComponent,
        SubNavbarComponent,
        LanguageSelectorComponent,
    ]
})
export class LayoutModule { }
